//Create a widget that displays the number of tenants in the system
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography, Box } from '@mui/material';
import Panel from '../../UI/Panel/Panel';
import BusinessIcon from '@mui/icons-material/Business';

export default function TenantCount() {
    const [tenantCount, setTenantCount] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get('/int/totaltenants').then(response => {
            setTenantCount(response.data.tenantCount);
            setLoading(false);
        });
    }, []);

    return (
        <Panel sx={{
            background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
            transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
            '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 25px rgba(0, 0, 0, 0.1)',
            }
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                p: 3
            }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2
                }}>
                    <Box sx={{
                        background: 'linear-gradient(135deg, #4a90e2 0%, #357abd 100%)',
                        borderRadius: '12px',
                        p: 1.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <BusinessIcon sx={{ fontSize: 32, color: '#fff' }} />
                    </Box>
                    <Typography variant="h6" color='primary' sx={{
                        fontWeight: 600,
                        letterSpacing: '0.5px'
                    }}>
                        Tenants
                    </Typography>
                </Box>
                
                <Box sx={{ pl: 1 }}>
                    <Typography variant="h3" color='secondary' sx={{
                        fontWeight: 700,
                        animation: loading ? 'pulse 1.5s infinite' : 'none',
                        '@keyframes pulse': {
                            '0%': { opacity: 1 },
                            '50%': { opacity: 0.7 },
                            '100%': { opacity: 1 },
                        }
                    }}>
                        {loading ? '...' : tenantCount}
                    </Typography>
                    <Typography variant="body2" sx={{
                        color: '#5c6bc0',
                        mt: 0.5,
                        fontWeight: 500
                    }}>
                        Total Active Organizations
                    </Typography>
                </Box>
            </Box>
        </Panel>
    );
}